import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsFamiliaComercialClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getFamiliaComercial(queries = {}) {
    try {
      const { data } = await this.api.get('/familia-comercial', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as familias comerciais');
    }
  }
}
